// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__3sEN-","breadCrumbsContainer":"Page_breadCrumbsContainer__3WZJs"};